import { render, staticRenderFns } from "./MinimalTextEditor.vue?vue&type=template&id=1d4682ee&"
import script from "./MinimalTextEditor.vue?vue&type=script&lang=js&"
export * from "./MinimalTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./MinimalTextEditor.vue?vue&type=style&index=0&id=1d4682ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports